import { render, staticRenderFns } from "./MoveToExcludedConfirmationPopup.vue?vue&type=template&id=48be47da&scoped=true&"
import script from "./MoveToExcludedConfirmationPopup.vue?vue&type=script&lang=js&"
export * from "./MoveToExcludedConfirmationPopup.vue?vue&type=script&lang=js&"
import style0 from "./MoveToExcludedConfirmationPopup.vue?vue&type=style&index=0&id=48be47da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48be47da",
  null
  
)

export default component.exports